"use client";
import {
  HovercardContextProvider
} from "../__chunks/EM5CXX6A.js";
import "../__chunks/MTZPJQMC.js";
import "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import "../__chunks/LMDWO4NN.js";
import {
  useHovercardStore
} from "../__chunks/FTXTWCCT.js";
import "../__chunks/O2PQ2652.js";
import "../__chunks/BM6PGYQY.js";
import "../__chunks/WYCIER3C.js";
import "../__chunks/YV4JVR4I.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/hovercard/hovercard-provider.tsx
import { jsx } from "react/jsx-runtime";
function HovercardProvider(props = {}) {
  const store = useHovercardStore(props);
  return /* @__PURE__ */ jsx(HovercardContextProvider, { value: store, children: props.children });
}
export {
  HovercardProvider
};
